import axios from './index'
// import store from '@/store'
import { cleanParams } from '@/filters'
// 分页获取
export const getDataTypeList = () => {
  // const currentRole = store.state.currentRole
  // const { companyId, teamId } = currentRole
  return axios.get('/welldbCombine/itemType', {
    params: cleanParams({
      // companyId,
      // teamId,
      pageNum: 1,
      pageSize: 1000
    })
  })
}
